module.exports = __webpack_public_path__ + "img/img-download.2d6cf1f5.png";